import './App.css';

/**
 * Calculates and displays longevity increase information based on the employee's appointed date and years of service.
 * 
 * @param {Object} props - The component props.
 * @param {string|Date} props.appointedDate - The date when the employee was appointed.
 * @param {number} props.longevity - The number of years the employee has been in service.
 * @returns {JSX.Element} A div element containing a header with longevity increase information.
 */
function LongevityDate(props) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  let appointedDate = new Date(props.appointedDate);
  let currentDate = new Date();
  let longevity = props.longevity;
  let yearsTillL5 = (4 - Math.floor(longevity));
  let nextLongevityDate = new Date(appointedDate).setFullYear(currentDate.getFullYear() + yearsTillL5);
  let step;
  let code;
  let content;

  // If longevity is less than 5
  if(props.longevity < 5) {
    content = "You will reach your first longevity increase on <strong>" + new Date(nextLongevityDate).toLocaleDateString("en-US", options) + ".</strong>";
  }
  // Else If longevity is grater than or equal to 22
  else if(props.longevity >= 22 || (props.longevity >= 15 && props.jobTitle == "paraprofessionals")) {
    content = "You have reached the highest longevity increase.";
  }
  else{
    if(props.jobTitle == "paraprofessionals"){
      if(longevity >= 5){
        step = "first"
        code = "L5 (five years)";
      }
    }
    else{
      if(longevity >= 5){
        step = "first"
        code = "L5 (five years)";
      }
      if(longevity >= 10){
        step = "second";
        code = "L10 (ten years)";
      }
      if(longevity >= 13){
        step = "thrid";
        code = "L13 (thirteen years)";
      }
      if(longevity >= 15){
        step = "fourth";
        code = "L15 (fifteen years)";
      }
      if(longevity >= 18){
        step = "fifth";
        code = "L18 (eighteen years)";
      }
      if(longevity >= 20){
        step = "sixth";
        code = "L20 (twenty years)";
      }
    }
    content = "You have reached your " + step + " longevity increase, " + code + ".";
  }
  
  return (
    <>
        <div className="longevity-date">
            <h2 className='sub-title' dangerouslySetInnerHTML={{__html: content}}></h2>
        </div>
    </>
  );
}

export default LongevityDate;